import { Feature } from "ol";
import { Circle } from "ol/geom";
import { Modify } from "ol/interaction";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import { globalStore } from "../state/store";
import Button from "ol-ext/control/Button";
import { Style } from "ol/style";
var $ = require("jquery");
export default class CircleLayer {
    constructor() {
        this.circlelayer = new VectorLayer({
            source: new VectorSource()
        });
        this.circle = new Circle([]);
        this.feature = new Feature(this.circle);
    }
    circleAddModify(atlas) {
        let pixel;
        let source = this.circlelayer.getSource();
        function getCenterOfExtent(Extent) {
            var X = Extent[0] + (Extent[2] - Extent[0]) / 2;
            var Y = Extent[1] + (Extent[3] - Extent[1]) / 2;
            return [X, Y];
        }
        function noCenterMove(evt) {
            var retVal = true;
            pixel = evt.pixel;
            source.forEachFeature(function (feature) {
                if (feature.getGeometry().getType() == 'Circle') {
                    var center = getCenterOfExtent(feature.getGeometry().getExtent());
                    let centerPixel = atlas.map.getPixelFromCoordinate(center);
                    if ((Math.abs(pixel[0] - centerPixel[0]) < 30) && (Math.abs(pixel[1] - centerPixel[1]) < 30)) {
                        retVal = false;
                        return true;
                    }
                }
            });
            return (retVal);
        }
        var modify = new Modify({
            source: this.circlelayer.getSource(),
            condition: noCenterMove,
            style: new Style({})
        });
        atlas.map.addInteraction(modify);
        modify.on("modifyend", () => {
            if (this.circle.getRadius() < 10 * 1000) {
                this.circle.setRadius(10 * 1000);
                $('#areaRadius').val(10 * 1000);
            }
            let rad = Math.floor(this.circle.getRadius() / 1000);
            this.circle.setRadius(rad * 1000);
            globalStore.dispatch("setSelectedGeometries", [this.circle]);
            $('#areaRadius').val(rad);
            setTimeout(() => {
                atlas.map.getView().fit(this.circle.getExtent(), { padding: [150, 50, 100, 100], duration: 1000, maxZoom: 19 });
            }, 500);
        });
        return true;
    }
    getCircleLayer() {
        return this.circlelayer;
    }
    getCircle() {
        return this.circle;
    }
    setCircle(coordinates, radius) {
        this.circle.setCenterAndRadius(coordinates, radius);
        this.circlelayer.getSource().clear();
        this.feature.setGeometry(this.circle);
        this.circlelayer.getSource().addFeature(this.feature);
        globalStore.dispatch("setSelectedGeometries", [this.circle]);
    }
    addCircle(coordinates, radius) {
        this.circle.setCenterAndRadius(coordinates, radius);
        this.feature.setGeometry(this.circle);
        this.circlelayer.getSource().addFeature(this.feature);
    }
    resetCircleLayer() {
        this.circlelayer.getSource().clear();
        globalStore.dispatch("setSelectedGeometries", []);
    }
    circleSelectRemoveButton(atlas) {
        return new Button({
            html: "R",
            className: "",
            title: "Remove Circle Selection",
            handleClick: () => {
                this.circlelayer.getSource().clear();
                globalStore.dispatch("setSelectedGeometries", []);
                globalStore.dispatch("setJobLocation", globalStore.getState().jobLocationsAll);
                atlas.zoomTo([0, 0], 1);
            },
        });
    }
}
